export const appendixScreenResolution = `
<p>When logged into Lloyds Bank Gem Connect, please use a static IP for the period of your session.</p>
<p><strong>System requirements for Gem Connect</strong></p>
<p>To get the best out of Gem Connect, make sure you’re using an operating system and internet browser from the list below. You might be able to use older versions, but some features may not work properly, and you could put your security at risk.</p>
<p>Only use operating systems and browsers which have been officially released. We might not be able to help you if you’re having issues while using beta or open-source build versions.</p>
<p><strong>Compatible operating systems</strong></p>
<ul class="padding-bottom-none">
    <li>Windows 10 or later</li>
    <li>macOS v11 or later</li>
</ul>
<p><strong>Compatible internet browsers</strong></p>
<ul class="padding-bottom-none">
    <li>Microsoft Edge 88 or later</li>
    <li>Google Chrome 88 or later</li>
    <li>Firefox 85 or later</li>
    <li>Safari 14 or later</li>
</ul>
<p><strong>Optimal screen resolution</strong></p>
<ul class="padding-bottom-none">
    <li>1920 x 1080</li>
</ul>`;


// WEBPACK FOOTER //
// ./src/components/content/appendices/1-screenResolutionCompatibility.ts